<template>
  <div class="h-screen">
    <HeaderBar :title="hTitle" />
    <div class="font-bold text-xl flex items-center my-2">
      <img src="../../../../../assets/icons/check.png" alt="" class="w-[16px] h-[16px] mr-4">
      Signed Contract to Sell</div>
    <!-- <a href="#">
      See more information of the Contract to Sell requirements here.
    </a> -->
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar },
};
</script>